import { Box, Text, Link, LinkProps } from '@chakra-ui/react';
import { ReactNode } from 'react';
import colors from 'src/theme/colors';
import fonts from 'src/theme/fonts';
import { Link as RouterLink } from 'react-router-dom';

interface NavigationLinkArgs extends LinkProps {
  isActive?: boolean;
  to?: string;
  children: ReactNode;
}

function NavigationLink({ isActive, to, children }: NavigationLinkArgs) {
  if (isActive) {
    return (
      <Box ml={['15px', '21px', '33px']} display="inline-block">
        <Text color={colors.white} fontFamily={fonts.bold} fontSize={['14px', '16px']}>
          {children}
        </Text>
      </Box>
    );
  }
  return (
    <Box ml={['15px', '21px', '33px']} display="inline-block">
      <Link
        asChild
        color={colors.white}
        _visited={{ color: colors.white }}
        opacity="0.8"
        textDecoration="none"
        fontSize={['14px', '16px']}
        _hover={{
          opacity: 0.6,
          textDecoration: 'none',
        }}
        _active={{
          opacity: 1,
        }}
      >
        <RouterLink to={to || '#'}>{children}</RouterLink>
      </Link>
    </Box>
  );
}

export default NavigationLink;
